module.exports = __webpack_public_path__ + "static/media/WaveApp_Ourbike_page.e4a52303.png";